var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from '../../components/CommonModal/index';
import { CheckBox, CheckboxWrapper, InputField, RichTextWrapper, } from './styles';
import { LabelBlock } from '../../components/CommonModal/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '../../store/versionNew/actions';
import { useErrorToast, useSuccessToast } from '../../utils/hooks/toast';
import { connect } from 'react-redux';
import makeSelectVersionNew from '../../store/versionNew/selectors';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { useAppIdFromURL } from '../utils/idFromURL';
import RTEditor from '../../components/Forms/Fields/RTEditor';
var NewVersionModal = function (_a) {
    var onCreateVersion = _a.onCreateVersion, setIsVisible = _a.setIsVisible, versionNewProps = _a.versionNewProps, isVisible = _a.isVisible;
    var appId = useAppIdFromURL();
    var _b = useState(''), versionName = _b[0], setVersionName = _b[1];
    var _c = useState(''), versionDescription = _c[0], setVersionDescription = _c[1];
    var _d = useState(false), silentUpdate = _d[0], setSilentUpdate = _d[1];
    useErrorToast('Error creating version(s)', [
        !(versionNewProps === null || versionNewProps === void 0 ? void 0 : versionNewProps.saving),
        versionNewProps === null || versionNewProps === void 0 ? void 0 : versionNewProps.error,
    ]);
    useSuccessToast('Version(s) created!', [
        !(versionNewProps === null || versionNewProps === void 0 ? void 0 : versionNewProps.saving),
        !(versionNewProps === null || versionNewProps === void 0 ? void 0 : versionNewProps.error),
    ]);
    var createVersion = function () { return __awaiter(void 0, void 0, void 0, function () {
        var version, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    version = {
                        name: versionName,
                        description: versionDescription,
                        silent_update: silentUpdate,
                    };
                    return [4 /*yield*/, onCreateVersion(appId, version)];
                case 1:
                    result = _a.sent();
                    if (result) {
                        setIsVisible(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Modal, { isVisible: isVisible, setIsVisible: setIsVisible, title: "New Version", modalBody: 
        /*=======================================================================================================*/
        _jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx(LabelBlock, { children: "Name" }), _jsx(InputField, { onChange: function (e) { return setVersionName(e.target.value); }, value: versionName, "aria-placeholder": "Enter publish name" })] }), _jsxs("div", { children: [_jsx(LabelBlock, { children: "Description" }), _jsx(RichTextWrapper, { children: _jsx(RTEditor, { value: versionDescription, onChange: setVersionDescription }) })] }), _jsxs(CheckboxWrapper, { children: [_jsx(CheckBox, { type: "checkbox", checkbox: true, name: "silent_update", onChange: function (e) { return setSilentUpdate(e.target.checked); }, checked: silentUpdate }), "Silent Update"] })] }), actionButtonContent: (versionNewProps === null || versionNewProps === void 0 ? void 0 : versionNewProps.saving) ? (_jsx(FontAwesomeIcon, { spin: true, icon: faSpinner })) : ('Publish New Version'), actionButtonOnClick: createVersion, isActionButtonDisabled: !versionName.length, cancelText: "Dismiss" }));
};
var mapStateToProps = function (state, ownProps) {
    return {
        isVisible: ownProps.isVisible,
        setIsVisible: ownProps.setIsVisible,
        versionNewProps: makeSelectVersionNew()(state),
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        onCreateVersion: function (appId, version) {
            return dispatch(actions.createVersion(appId, version));
        },
    };
};
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default withConnect(NewVersionModal);
